import type { AuthInvitationDetails } from "@/store/slices/authV2Slice";

const getInvitationTitle = ({
  tenancyName,
  organisationName,
}: Pick<AuthInvitationDetails, "tenancyName" | "organisationName">) => {
  if (organisationName !== tenancyName) {
    return `You've been invited to join ${organisationName} (part of ${tenancyName}).`;
  }
  return `You've been invited to join ${tenancyName}.`;
};

export { getInvitationTitle };
